import { Breadcrumb } from '@app/components/layout/page/components/page-breadcrumb';
import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupUsers } from '@shared/api/hooks/group/users';
import { parseAsString, useQueryState } from 'nuqs';
import { useParams } from 'react-router-dom';
import GroupUsersTable from '../components/tables/group-users-table';
import { GROUP_ROUTES } from '../config/pages';

export default function GroupOrganizationUsersPage() {
  const { org_uuid: orgUuid } = useParams<{ org_uuid: string }>();
  const [orgName] = useQueryState('org', parseAsString);
  const [search] = useQueryState('name', parseAsString);
  const { page, perPage } = useDataTableQueryState();

  const data = useGetGroupUsers({
    organization: orgUuid,
    page,
    page_size: perPage,
    search: search || undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load organisation users');

  const breadcrumbs: Breadcrumb[] = [
    { label: 'Organisations', url: GROUP_ROUTES.ORGANIZATIONS },
  ];

  return (
    <Page name="group-organization-users" title={orgName ?? 'Users'}>
      <PageHeader name={orgName ?? 'Users'} breadcrumbs={breadcrumbs} />
      <GroupUsersTable {...data} pageCount={pageCount} />
    </Page>
  );
}
